module.exports = __webpack_public_path__ + "img/defaultVoucherIco.7328daa1.png";